import { useEffect, useRef } from 'react';
import { useModal } from '../../context/ModalContext';

const DESKTOP_SRC = "https://www.youtube.com/embed/AQRah6clrQ8";
const MOBILE_SRC  = "https://www.youtube.com/embed/v9Yzn50Laz0";

const ModalVideo = ({ data }) => {
  const { isModalOpen } = useModal();
  const desktopRef = useRef(null);
  const mobileRef  = useRef(null);

  useEffect(() => {
    if (isModalOpen) {
      if (desktopRef.current) desktopRef.current.src = DESKTOP_SRC;
      if (mobileRef.current)  mobileRef.current.src  = MOBILE_SRC;
    } else {
      // Limpa o src para forçar o iframe a parar o áudio/vídeo
      if (desktopRef.current) desktopRef.current.src = '';
      if (mobileRef.current)  mobileRef.current.src  = '';
    }
  }, [isModalOpen]);

  return (
    <div className="ModalVideo">
      {/* Desktop / Tablet */}
      <div className="d-none d-md-block position-relative rounded overflow-hidden shadow" style={{ aspectRatio: '16/9' }}>
        <iframe ref={desktopRef} className="w-100 h-100" src={DESKTOP_SRC} title="YouTube video player" frameBorder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerPolicy="strict-origin-when-cross-origin" allowFullScreen style={{ position: 'absolute', inset: 0 }}></iframe>
      </div>
      {/* Mobile (Short) */}
      <div className="d-block d-md-none position-relative rounded overflow-hidden shadow mx-auto" style={{ aspectRatio: '9/16', maxWidth: 360 }}>
        <iframe ref={mobileRef} className="w-100 h-100" src={MOBILE_SRC} title="YouTube video player" frameBorder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerPolicy="strict-origin-when-cross-origin" allowFullScreen style={{ position: 'absolute', inset: 0 }}></iframe>
      </div>
    </div>
  );
};

export default ModalVideo;
